import { NavLink } from 'react-router-dom'
import { 
  Home, 
  DollarSign, 
  CheckSquare, 
  Calendar, 
  ShoppingCart, 
  Users, 
  Package,
  Heart,
  Settings,
  MapPin,
  Video,
  Navigation,
  BarChart3,
  BookOpen,
  Music2
} from 'lucide-react'
import { motion } from 'framer-motion'

const Sidebar = ({ onClose }) => {
  const navigation = [
    { name: 'Dashboard', href: '/dashboard', icon: Home },
    { name: 'A Nossa Família', href: '/family-management', icon: Users },
    { name: 'Finanças', href: '/finance', icon: DollarSign },
    { name: 'Tarefas', href: '/tasks', icon: CheckSquare },
    { name: 'Calendário', href: '/calendar', icon: Calendar },
    { name: 'Saúde', href: '/health', icon: Heart },
    { name: 'Compras', href: '/shopping', icon: ShoppingCart },
    { name: 'Mural da Família', href: '/family-board', icon: Users },
    { name: 'Controle de Itens', href: '/items-control', icon: Package },
    { name: 'Localização da Família', href: '/family-geo', icon: Navigation },
    { name: 'Analytics', href: '/analytics', icon: BarChart3 },
    { name: 'Localizador', href: '/locator', icon: MapPin },
    { name: 'Sala de Vídeo', href: '/video-room', icon: Video },
    { name: 'Minha Canção Preferida', href: '/favorite-songs', icon: Music2 },
  ]

  const NavItem = ({ item }) => (
    <NavLink
      to={item.href}
      onClick={onClose}
      className={({ isActive }) =>
        `group flex items-center px-3 py-2 text-sm font-medium rounded-lg transition-colors duration-200 ${
          isActive
            ? 'bg-primary-100 text-primary-700'
            : 'text-neutral-600 hover:bg-neutral-100 hover:text-neutral-900'
        }`
      }
    >
      {({ isActive }) => (
        <>
          <item.icon
            className={`mr-3 h-5 w-5 flex-shrink-0 transition-colors duration-200 ${
              isActive ? 'text-primary-500' : 'text-neutral-400 group-hover:text-neutral-500'
            }`}
          />
          <motion.span
            initial={false}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.2 }}
          >
            {item.name}
          </motion.span>
        </>
      )}
    </NavLink>
  )

  return (
    <div className="flex h-full flex-col bg-white border-r border-neutral-200">
      {/* Logo */}
      <div className="flex h-16 items-center px-6 border-b border-neutral-200">
        <div className="flex items-center">
          <div className="h-8 w-8 rounded-lg bg-primary-500 flex items-center justify-center">
            <Home className="h-5 w-5 text-white" />
          </div>
          <div className="ml-3">
            <h1 className="text-lg font-semibold text-neutral-900">Domusfamilyhub</h1>
            <p className="text-xs text-neutral-500">Organizador Familiar</p>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 space-y-1 px-3 py-4">
        {navigation.map((item) => (
          <NavItem key={item.name} item={item} />
        ))}
      </nav>

      {/* Bottom section */}
      <div className="border-t border-neutral-200 p-3 space-y-1">
        <NavLink
          to="/guide"
          onClick={onClose}
          className={({ isActive }) =>
            `group flex items-center px-3 py-2 text-sm font-medium rounded-lg transition-colors duration-200 ${
              isActive
                ? 'bg-primary-100 text-primary-700'
                : 'text-neutral-600 hover:bg-neutral-100 hover:text-neutral-900'
            }`
          }
        >
          {({ isActive }) => (
            <>
              <BookOpen className={`mr-3 h-5 w-5 flex-shrink-0 transition-colors duration-200 ${
                isActive ? 'text-primary-500' : 'text-neutral-400 group-hover:text-neutral-500'
              }`} />
              Manual do Usuário
            </>
          )}
        </NavLink>
        <NavLink
          to="/settings"
          onClick={onClose}
          className={({ isActive }) =>
            `group flex items-center px-3 py-2 text-sm font-medium rounded-lg transition-colors duration-200 ${
              isActive
                ? 'bg-primary-100 text-primary-700'
                : 'text-neutral-600 hover:bg-neutral-100 hover:text-neutral-900'
            }`
          }
        >
          {({ isActive }) => (
            <>
              <Settings className={`mr-3 h-5 w-5 flex-shrink-0 transition-colors duration-200 ${
                isActive ? 'text-primary-500' : 'text-neutral-400 group-hover:text-neutral-500'
              }`} />
              Configurações
            </>
          )}
        </NavLink>
      </div>
    </div>
  )
}

export default Sidebar



